/**
 * This utility enables programmatic navigation outside of React components.
 * It creates a custom history listener that updates when the router navigates.
 */

// This will hold the navigate function once it's available
let navigateFunction = null;

// Function to set the navigate function (called from App component)
export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

// Function to navigate programmatically from anywhere
export const navigateTo = (path) => {
  if (navigateFunction) {
    navigateFunction(path);
    return true;
  } else {
    console.warn('Navigation function not set. Falling back to window.location');
    window.location.href = path;
    return false;
  }
}; 